import React, {useState, useEffect} from "react";
import {Container, LabelContainer} from "./AdditionalSkills.styles";
import {CheckboxInput} from "../Inputs/CheckboxInput";
import {SkillsProps} from "../../utils/types";
import { HygienistSkill } from "utils/constants";

export const Label = ({label, description, style}: { label: string, description: string, style?: any }) => {
    return (
        <LabelContainer style={style}>
            <div className={'label'}>{label}</div>
            <div className={'description'}>{description}</div>
        </LabelContainer>
    )
}

interface AdditionalSkillsProps {
    skills: HygienistSkill[],
    checkedSkills: HygienistSkill[],
    state: string,
    disabled: boolean,
    qualificationSkill?: HygienistSkill,
}

export default function AdditionalSkills({skills, state, disabled, checkedSkills, qualificationSkill}: AdditionalSkillsProps) {
    const [checkedSkillIds, setCheckedSkillIds] = useState<number[]>(checkedSkills.map(skill => skill.id) || [])

    useEffect(() => {
        setCheckedSkillIds(checkedSkills.map(skill => skill.id) || [])
    }, [checkedSkills])

    const shouldLimitSkills = (skill: HygienistSkill) => {
        if (skill.hygienistType === 1 && qualificationSkill) {
            const limitedQualifications = ["CDA1", "HFTDA", "NHFTDA"];
            if (limitedQualifications.includes(qualificationSkill.name)) {
                return skill.id < 13;
            }
        }
        return true;
    }

    return (
        <Container>
            <div className={'skills'}>My Additional Skills & Training</div>
            {skills.map((skill: HygienistSkill) => {
                if (!skill.qualification && !skill.license && shouldLimitSkills(skill)) {
                    const checkedSkill = !!checkedSkillIds.find(id => id === skill.id)
                    return (
                        <CheckboxInput
                            key={skill.id}
                            className={'labelContainer no-fastclick'}
                            onChange={(e) => {
                                if(e.target?.checked) {
                                    setCheckedSkillIds([...checkedSkillIds, skill.id])
                                } else {
                                    setCheckedSkillIds(checkedSkillIds.filter(id => id !== skill.id))
                                }
                            }}
                            checked={!disabled && checkedSkill}
                            disabled={disabled}
                            name={skill.name}
                            label={
                                <div className="list-block inset">
                                    <Label
                                        label={skill.label}
                                        description={skill.description.replace('{{province}}', state)}
                                    />
                                </div>
                            }
                        />
                    )
                }
                return null;
            })}
        </Container>
    )
}
